import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=c5b0df5c&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/results.css?vue&type=style&index=0&id=c5b0df5c&scoped=true&lang=css&"
import style1 from "@/resources/styles/meme.css?vue&type=style&index=1&id=c5b0df5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b0df5c",
  null
  
)

export default component.exports